import { createContext, useContext } from 'react';

// Drawer de configuration en mode compact (cf. ConfigDrawer) : écran trop petit
// pour le Drawer pleine largeur et l'aperçu de page côte à côte. Un onglet peut
// y resserrer sa mise en page. Hors du Drawer (pas de Provider) : false.
const ConfigCompactContext = createContext(false);

export const ConfigCompactProvider = ConfigCompactContext.Provider;

export const useConfigCompact = () => useContext(ConfigCompactContext);
